<template>
  <div class="pending-renewals-container">
    <form @submit.prevent="searchPendingSignatures">
      <div class="form-group row">
        <div class="col-xxl-3 col-xl-3 col-lg-6 col-md-6 mb-4">
          <label>Group Name</label>
          <input v-model="filters.group_name" type="text" class="page-search-field" placeholder="Enter Group Name" />
        </div>
        <div class="col-xxl-3 col-xl-3 col-lg-6 col-md-6 mb-4">
          <label>Group Code</label>
          <input v-model="filters.group_code" type="text" class="page-search-field" placeholder="Enter Group Code" />
        </div>
        <div class="col-xxl-3 col-xl-3 col-lg-6 col-md-6 mb-4">
          <label>Group Email</label>
          <input v-model="filters.group_email" type="email" class="page-search-field" placeholder="Enter Group Email" />
        </div>
        <!-- <div class="col-xxl-3 col-xl-3 col-lg-6 col-md-6 mb-4">
          <label>Enrollment Date</label>
          <div class="enrollmentDate-picker">
            <date-picker @input="setToDate" input-class="page-search-field" placeholder="From" type="date"
              v-model="filters.enrollment_from" value-type="format" :disabled-date="(date) => {
                  return disabledAfterCurrentDate(date, 'start');
                }
                "></date-picker>
  
            <date-picker input-class="page-search-field" placeholder="To" type="date" v-model="filters.enrollment_to"
              value-type="format" :disabled="disableDate" :disabled-date="(date) => {
                  return disabledAfterCurrentDate(date, 'end');
                }
                "></date-picker>
          </div>
        </div> -->
         <input-multi-select
            labelFor="status"
            labelName="Status"
            inputName="status"
            :vmodel.sync="filters.status"
            :options="statuses.map((type) => type.value)"
            :custom-label="(opt) => statuses.find((x) => x.value == opt).text"
            formGroupClass="col-xxl-3 col-xl-3 col-lg-6 col-md-6 mb-4"
            placeholder="Select Status"
          />
        </div>
        <!-- <div class="form-group row">
        <div class="col-xxl-3 col-xl-3 col-lg-6 col-md-6 mb-4">
          <label>State</label>
          <multiselect name="state" v-model="filters.state" placeholder="Select State"
            :options="stateList.map((type) => type.value)"
            :custom-label="(opt) => stateList.find((x) => x.value == opt).text" />
        </div>
      </div> -->
      <div class="row justify-content-md-end">
        <div class="col-xxl-2 col-xl-3">
          <button type="submit" class="univ-btn" @click="searchPendingSignatures">Search</button>
        </div>
      </div>
    </form>
  </div>

</template>
<script>
import Api from "@/resource/Api";
import Helper from "@/resource/Helper";
export default {
  name: "PendingRenewalsFilter",
  props: {
    filters: {
      required: true,
      type: Object,
    },
  },
  data() {
    return {
      stateList: Helper.getStates(),
      groups: [],
      disableDate: true,
      statuses: [
        { text: "ALL", value: " " },
        { text: "ACTIVE", value: "1" },
        { text: "INACTIVE", value: "0" },
      ],
    };
  },
  created() {
    this.getGroups();
  },
  methods: {
    searchPendingSignatures() {
      this.$emit("onSearch", this.filters);
    },
    searchHandler(query) {
      if (query.length > 2) {
        this.getGroups(query);
      }
    },
    getGroups(query = "") {
      let url;
      if (query) {
        url = `v2/get-rep-group-list?size=100&group_name=${query}`;
      } else {
        url = `v2/get-rep-group-list?size=100`;
      }
      Api.get(url).then((res) => {
        this.groups = res.data.data;
      });
    },
    disabledAfterCurrentDate(date, type) {
      const formattedDate = new Date(new Date().setHours(0, 0, 0, 0));
      if (type == "end") {
        if (
          date <
          new Date(new Date(this.filters.enrollment_from).setHours(0, 0, 0, 0))
        ) {
          return true;
        }
      }
      return (
        date >
        formattedDate.setDate(formattedDate.getDate() - +(type == "start"))
      );
    },
    setToDate(date) {
      if (date) {
        this.disableDate = false;
      } else {
        this.filters.enrollment_to = "";
        this.disableDate = true;
      }
    },
  },
};
</script>
<style>
.pending-renewals-container .multiselect {
  box-sizing: content-box;
  display: block;
  position: relative;
  width: 100% !important;
  min-height: 40px;
  text-align: left;
  color: #35495e;
  margin-left: 0px !important;
}

.pending-renewals-container .effective_date .mx-datepicker {
  width: 100% !important;
}
</style>